import { render } from "./Lot.vue?vue&type=template&id=7efe72ce"
import script from "./Lot.vue?vue&type=script&lang=js"
export * from "./Lot.vue?vue&type=script&lang=js"
script.render = render

export default script